<template>
  <div class="nested-table">
    <b-modal
      :static="true"
      dialog-class="modal-table"
      v-model="tableRowModal.show"
      centered
    >
      <template v-slot:modal-header="{ close }">
        <h5>{{ tableRowModal.title }}</h5>

        <button type="button" aria-label="Close" class="close" @click="checkClose()">
          <span class="material-icons">
            close
          </span>
        </button>
      </template>
      <div class="table_theme-info">
        <b-table :items="tableRowModal.items" :fields="modalFields">
          <template
            v-for="slot in modalSlots"
            v-slot:[`cell(${slot.name})`]="data"
          >
            <slot :name="`modal-${slot.name}`" v-bind="data"> </slot>
          </template>
          <template v-slot:cell(more)="data">
            <slot name="modal-buttonShow" :buttonShow="data" v-bind="data">
              <b-button
                size="sm"
                class="button btn-icon"
                variant="secondary"
                @click="data.toggleDetails"
              >
                <span class="material-icons">
                  {{
                    data.detailsShowing
                      ? "keyboard_arrow_up"
                      : "keyboard_arrow_down"
                  }}
                </span>
              </b-button>
            </slot>
          </template>
          <template v-slot:row-details="data">
            <slot name="modal-row" :row="data"></slot>
          </template>
        </b-table>
      </div>
      <template v-slot:modal-footer>
        <b-button
          variant="primary"
          class="button"
          @click="checkClose()"
        >
          Close
        </b-button>
      </template>
    </b-modal>
    <b-table
      style="margin-bottom: 0;"
      :tbody-transition-props="transProps"
      :items="items"
      :fields="fields"
      fixed
    >
      <template v-slot:[`cell(${slot.name})`]="data" v-for="slot in slots">
        <slot :name="slot.name" v-bind="data"> </slot>
      </template>
      <template v-slot:cell(more)="data">
        <b-button
          size="sm"
          class="button btn-icon"
          variant="secondary"
          v-if="buttonShow"
          @click.prevent="showView(data)"
        >
          <slot name="buttonShow" :buttonShow="data">
            <span class="material-icons">
              read_more
            </span>
          </slot>
        </b-button>
      </template>
      <template v-slot:row-details="data">
        <slot name="row" :row="data"></slot>
      </template>
    </b-table>
    <slot name="total" v-if="showTotalTable">
      <b-table
        class="table__total"
        :items="totalItems"
        :fields="totalFields"
        fixed
      >
      </b-table>
    </slot>
  </div>
</template>

<script>
export default {
  name: 'NestedTable',
  props: {
    isRemove: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    slots: {
      type: Object,
      default: () => {}
    },
    slotProps: {
      type: Object
    },
    items: {
      type: [Array, Object]
    },
    totalItems: {
      type: Array
    },
    totalFields: {
      type: Array
    },
    fields: {
      type: Array
    },
    buttonShow: {
      type: Boolean,
      default: true
    },
    showTotalTable: {
      type: Boolean,
      default: true
    },
    modalSlots: {
      type: Object,
      default: () => {}
    },
    modalFields: {
      type: Array
    },
    rowName: {
      type: String
    },
    funcModalTitle: {
      type: Function
    },
    currentEdit: {
      type: [String, null],
      default: ''
    }
  },
  computed: {
    rows () {
      return this.items.length
    }
  },
  data () {
    return {
      tableRowModal: {
        show: false,
        items: null,
        title: null
      },
      transProps: {
        name: 'flip-list'
      }
    }
  },
  watch: {
    fields (v) {
      this.fields = v
    },
    currentEdit (v) {
      this.currentEdit = v
    }
  },
  methods: {
    showView (row) {
      this.tableRowModal.show = true
      this.tableRowModal.items = row.item[this.rowName]

      if (this.funcModalTitle) {
        this.setModalTitle(row.item)
      }
    },
    setModalTitle (row) {
      this.tableRowModal.title = this.funcModalTitle(this.slotProps, row)
    },
    async checkClose () {
      if (this.currentEdit) {
        const confirm = await this.$root.$confirm.open(
          'Close Modal',
          'Are you sure you don\'t want to keep the changes?'
        )
        if (confirm) {
          this.tableRowModal.show = false
          this.$emit('close-edit', true)
        }
      } else {
        this.tableRowModal.show = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.nested-table ::v-deep table {
  table-layout: unset !important
}

</style>
